import { AxiosResponse } from "axios";
import { ProductDataMapper } from "@/data/persistences/mappers/ProductDataMapper";
import { ProductConfigurationRule } from "@/domain/entities/Product";

// ProductV4Mapper — clone/delegate ProductDataMapper sementara untuk response existing
export class ProductV4Mapper {
  private delegate = new ProductDataMapper();

  public convertProductConfigurationRule(
    res: AxiosResponse<any>
  ): ProductConfigurationRule[] {
    return this.delegate.convertDataProductConfigurtionRule(res).data;
  }
}
